
import React, { useEffect, useState } from 'react';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { FaEdit, FaUserPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import Swal from 'sweetalert2';
import { successAlertRefresh } from '../CommonUtils/SweetAlerts';
// import arrowGif from "../dist/images/arrow.gif";
// import arrowGif from "../images/arroww.gif";
import { BiTrash } from "react-icons/bi";

const T = {
    navy: '#1a3a5c',
    font: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
};

const S = {
    page: {

    },
    topBar: {
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '24px', flexWrap: 'wrap', gap: '12px',
    },
    titleGroup: { display: 'flex', alignItems: 'center', gap: '12px' },
    titleIcon: {
        width: '44px', height: '44px', borderRadius: '12px',
        background: `linear-gradient(135deg, ${T.navy}, #2563a8)`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#fff', fontSize: '18px', flexShrink: 0,
        boxShadow: '0 4px 12px rgba(26,58,92,0.3)',
    },
    titleText: { fontSize: '20px', fontWeight: '700', color: T.navy, margin: 0 },
    titleSub: { fontSize: '12px', color: '#94a3b8', margin: 0, marginTop: '2px' },
    newBtn: {
        display: 'flex', alignItems: 'center', gap: '7px',
        padding: '10px 20px', background: '#22c55e', color: '#fff',
        border: 'none', borderRadius: '8px', fontWeight: '700',
        fontSize: '13.5px', cursor: 'pointer', fontFamily: T.font,
    },
    emptyState: { padding: '64px 20px', textAlign: 'center' },
};

export default function FacultydetailsEdit() {

    const [univemp, setUnivemp] = useState([]);
    const navigate = useNavigate();

    function GetUnivEmpList() {
        CommonAxiosGet(`${config.url.FAC_URL}getUniversityEmployees`).then((res) => {
            setUnivemp(res?.data?.scode === "01" ? res.data.data || [] : []);
        });
    }


    function handleDelete(cfmsId) {
        Swal.fire({
            text: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'Cancel',
            backdrop: false,
            confirmButtonColor: '#d32f2f',
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.FAC_URL}deletecfmsdata?cfmsId=${cfmsId}`;
                console.log("Delete URL:", url); // Debug log
                CommonAxiosPost(url).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlertRefresh(res?.data?.sdesc);

                    } else {
                        Swal.fire(res?.data?.sdesc || "Deletion failed", "", "error");
                    }
                });
            }
        });
    }



    const [dashboardcount, setDashboardcount] = useState([]);
    function GetDashboardCount() {
        let url = `${config.url.FAC_URL}getDashboardData`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setDashboardcount(res.data.data || []);
            } else {
                setDashboardcount([]);
            }
        });
    }
    useEffect(() => {


        GetUnivEmpList(); GetDashboardCount();

    }, []);
    const columns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "cfms_id",
            header: "CFMS Id",
            accessorKey: "cfms_id",
            meta: { style: { textAlign: "center" } },
        },
        {
            id: "emp_full_name",
            header: "Employee Name",
            accessorKey: "emp_full_name",
        },
        {
            id: "mobile",
            header: "Mobile No",
            accessorKey: "mobile",
        },
        {
            id: "masked_aadhar",
            header: "Aadhaar No",
            accessorKey: "masked_aadhar",
        },
        {
            id: "post_desc",
            header: "Designation",
            accessorKey: "post_desc",
        },
        {
            id: "nature_of_post_name",
            header: "Post",
            accessorKey: "nature_of_post_name",

        },
        {
            id: "actions",
            header: "Edit / Delete",
            cell: ({ row }) => (
                <div style={{ display: "flex", gap: "5px" }}>
                    <button
                        type="button"

                        className='btn btn-sm btn-primary '
                        onClick={() => navigate("/Universiyedit", { state: { facultyData: row.original } })}
                    >
                        <FaEdit size={13} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-danger d-flex align-items-center"
                        onClick={() => handleDelete(row.original.cfms_id)}
                    >
                        <BiTrash size={16} />
                    </button>
                </div>

            ),
        },
    ];

    const totalCounts = dashboardcount.reduce(
        (acc, item) => {
            acc.total += Number(item.total || 0);
            acc.pending += Number(item.pending || 0);
            acc.completed += Number(item.completed || 0);
            return acc;
        },
        { total: 0, pending: 0, completed: 0 }
    );
    return (
        <div className='faculty-card'>


            <div className="fac-topbar">
                <div className="fac-detnew">
                    <h5 className="mb-0">University Faculty Details</h5>
                </div>
                <button
                    className="newfacbtn"
                    onClick={() =>
                        navigate("/Universiyedit", { state: { facultyData: null } })
                    }
                >
                    <FaUserPlus size={14} /> New Faculty
                </button>

            </div>

            {/* 
            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}>
                {dashboardcount?.map((item, index) => (
                    <div
                        key={index}
                        className='newdd-card'
                    >
                        <div
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                textAlign: "center",
                                marginBottom: "15px",
                                color: "#1f2937"
                            }}
                        >
                            {item.nature_of_post_name === "regular"
                                ? "Regular"
                                : item.nature_of_post_name === "contract"
                                    ? "Contract"
                                    : item.nature_of_post_name}
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>

                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#eef2ff",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Total
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#2563eb" }}>
                                    {item.total}
                                </span>
                            </div>

                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#fff7ed",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Pending
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#f59e0b" }}>
                                    {item.pending}
                                </span>
                            </div>

                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#ecfdf5",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Completed
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#16a34a" }}>
                                    {item.completed}
                                </span>
                            </div>

                        </div>
                    </div>
                ))}
            </div> */}



            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}>
                {dashboardcount?.map((item, index) => (
                    <div
                        key={index}
                        className='newdd-card'
                    >
                        {/* Title */}
                        <div>
                            <h5>{item.nature_of_post_name === "regular"
                                ? "Regular"
                                : item.nature_of_post_name === "contract"
                                    ? "Contract"
                                    : item.nature_of_post_name}</h5>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", gap: '10px' }}>

                            {/* Total */}
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#eef2ff",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Total
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#2563eb" }}>
                                    {item.total}
                                </span>
                            </div>

                            {/* Pending */}
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#fff7ed",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Pending
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#f59e0b" }}>
                                    {item.pending}
                                </span>
                            </div>

                            {/* Completed */}
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    background: "#ecfdf5",

                                }}
                                className='countdd-new'
                            >
                                <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                    Completed
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: "700", color: "#16a34a" }}>
                                    {item.completed}
                                </span>
                            </div>

                        </div>
                    </div>
                ))}



                <div

                    className='newdd-card'
                >
                    <div  >
                        <h5>Total</h5>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", gap: '10px' }}>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#eef2ff",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Total
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#2563eb" }}>
                                {totalCounts.total}
                            </span>
                        </div>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#fff7ed",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Pending
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#f59e0b" }}>
                                {totalCounts.pending}
                            </span>
                        </div>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#ecfdf5",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Completed
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#16a34a" }}>
                                {totalCounts.completed}
                            </span>
                        </div>

                    </div>
                </div>
            </div>


            {/* <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}> */}
            {/* {dashboardcount?.map((item, index) => ( */}
            {/* <div

                    className='newdd-card'
                >
                    <div  >
                        <h5>Total</h5>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", gap: '10px' }}>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#eef2ff",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Total
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#2563eb" }}>
                                {totalCounts.total}
                            </span>
                        </div>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#fff7ed",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Pending
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#f59e0b" }}>
                                {totalCounts.pending}
                            </span>
                        </div>

                        <div
                            style={{
                                textAlign: "center",
                                padding: "10px",
                                borderRadius: "8px",
                                background: "#ecfdf5",

                            }}
                            className='countdd-new'
                        >
                            <span style={{ fontSize: "12px", display: "block", color: "#6b7280" }}>
                                Completed
                            </span>
                            <span style={{ fontSize: "20px", fontWeight: "700", color: "#16a34a" }}>
                                {totalCounts.completed}
                            </span>
                        </div>

                    </div>
                </div> */}
            {/* ))} */}
            {/* </div> */}
            {/* ── Table ── */}
            {univemp.length > 0 ? (
                <CommonReactTable
                    data={univemp}
                    columns={columns}
                    headerName="University Professor List"
                    showFooter={false}
                    showPagination={true}
                    showExcel={true}
                    showPrint={true}
                    excelFileName="University_Professor_List"
                />
            ) : (
                <div style={S.emptyState}>
                    <div style={{ fontSize: '42px', marginBottom: '12px', opacity: 0.3 }}>🎓</div>
                    <p style={{ fontWeight: '700', color: '#c0392b', margin: 0, fontSize: '15px' }}>No Data Found</p>
                    <p style={{ color: '#bbb', fontSize: '13px', marginTop: '6px' }}>Add a new faculty member to get started.</p>
                </div>
            )}
        </div>
    );
}